
export default class Validation {

    static validateEmail(wasValid, value, force) {
        
        var emailValid = false;

        if(!wasValid || force) {
            var longEnough = value.length > 0;
            var indexOfAt = value.indexOf('@');
            var charBeforeAt = value.slice(0, indexOfAt).length > 0;
            var charAfterAt = value.slice(indexOfAt, value.length - 1).length > 0;
    
            emailValid = longEnough && indexOfAt > -1 && charBeforeAt && charAfterAt;
        }
        
        return emailValid;
    }

    static validatePassword(value, force) {

        var passwordValid = false;
        
        if(!this.state.passwordValid || force) {
            passwordValid = value.length > 0;
        }

        return passwordValid;
    }
}